import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Additional attributes that can be applied to the `}<inlineCode parentName="p">{`HTMLInputElement`}</inlineCode>{` wrapped by `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{`.`}</p>
    <p>{`Any attribute that would be valid on an `}<inlineCode parentName="p">{`<input>`}</inlineCode>{` can be used here, however:  `}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` is taken directly from the `}<inlineCode parentName="li">{`CardSecurityCodeInputOptions`}</inlineCode>{` options  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`maxLength`}</inlineCode>{` and `}<inlineCode parentName="li">{`minLength`}</inlineCode>{` will be inferred from the `}<inlineCode parentName="li">{`cardNetwork`}</inlineCode>{`  `}</li>
      <li parentName="ul">{`type is always set to `}<inlineCode parentName="li">{`tel`}</inlineCode>{` to provide a good UX when typing on a virtual keyboard  `}</li>
      <li parentName="ul">{`for security reasons event handlers such as `}<inlineCode parentName="li">{`onkeydown`}</inlineCode>{`, `}<inlineCode parentName="li">{`onkeyup`}</inlineCode>{` won't be serialized and passed down to the input`}</li>
    </ul>
    <p>{`You can pass other attributes such as `}<inlineCode parentName="p">{`data-*`}</inlineCode>{`, `}<inlineCode parentName="p">{`aria-*`}</inlineCode>{`...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      